// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { id } from "date-fns/locale";
import { PermitToWorkGeometryModel } from "../../../../../api/APIClient";

export enum ViewerMode {
    Default = 1,
    AssetInfo,
    PermitsToWork,
    PowerBI,
    PowerBIonModel,
    AssetControl,
    AssetHealth,
    AssetTemperature,
    AssetPresure,
    AssetConexions,
    AssetSelected,
    AlarmsHeatMap,
    EditAsset,
    Navigaion,
    // Prueba3DModel,
    // Calendar,
    Planning,
    Interferences,
    Resources,
    Coordinates,
    Wings,
    Heatmaps,
}

export interface IPermitToWorkGeometryToCollisions {
    permitId: string;
    // shape: string;
    center: THREE.Vector3;
    radius: number;
    height: number;
    boundingBox: ISizeVector3;
}

export interface IShowLabelsPermitsToWork {
    tag: string;
    id: string;
}

export interface ISizeVector3 {
    sizeX: number;
    sizeY: number;
    sizeZ: number;
}

export interface IRuleSetCollisionResult {
    mesh1: { asset: string; meshId: string };
    mesh2: { asset: string; meshId: string };
}

export interface IPermitToWorkCollision {
    id: string;
    dbIds: number[];
    geometry: PermitToWorkGeometryModel | undefined;
}

export interface ILabelInfo {
    id: string;
    title: string;
    data: { [key: string]: string };
}

export interface ILabelInfoData {
    title: string;
    text: string;
}

export interface IWOCollisionInfo {
    id: string;
    startDate: Date;
    dueDate: Date;
}

export interface IElementsCollision {
    workOrderId1: string;
    workOrderId2: string;
}

export interface ICollisions {
    collisions: Array<IElementsCollision>;
    workTypes: Array<string>;
}

export const returnMidValue = (arr: number[]): number | null => {
    // Asegurar que la array no está vacía
    if (arr.length === 0) {
        return null;
    }

    // Calcular el índice del medio
    const midIndex = Math.floor(arr.length / 2);

    // Si la longitud de la array es impar, devolver el valor del medio
    if (arr.length % 2 === 1) {
        return arr[midIndex];
    }

    // Si la longitud de la array es par, devolver el valor del medio inferior
    return arr[midIndex - 1];
};

export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const colorNameToRGB = (name: string): { r: number; g: number; b: number } => {
    // Create fake div
    const fakeDiv = document.createElement("div");
    fakeDiv.style.color = name;
    document.body.appendChild(fakeDiv);

    // Get color of div
    const cs = window.getComputedStyle(fakeDiv);
    const rgb = cs.getPropertyValue("color");

    // Remove div after obtaining desired color value
    document.body.removeChild(fakeDiv);

    const sep = rgb.indexOf(",") > -1 ? "," : " ";
    const rgbSplit = rgb.substring(4).split(")")[0].split(sep);
    const rgbArray = rgbSplit.map((value) => parseInt(value, 10));

    return {
        r: rgbArray[0],
        g: rgbArray[1],
        b: rgbArray[2],
    };
};

export const colorHexToVector4 = (colorHex: string, opacity: number): THREE.Vector4 => {
    const color = new THREE.Color(colorHex);
    return new window.THREE.Vector4(color.r, color.g, color.b, opacity);
};

export const colorHexToRgb = (colorHex: string): THREE.Color => {
    const color = new THREE.Color(colorHex);
    return color;
};

export const convertHexToRGB = (colorHex: string | undefined): string => {
    if (colorHex?.length !== 7 || undefined) {
        return "rgb(255, 255, 255)";
    }
    const color1 = colorHex.slice(1);
    const aRgbHex = color1.match(/.{1,2}/g);
    const aRgb = [parseInt(aRgbHex[0], 16), parseInt(aRgbHex[1], 16), parseInt(aRgbHex[2], 16)];
    const rgb = `rgb(${aRgb[0]}, ${aRgb[1]}, ${aRgb[2]})`;
    return rgb;
};

export const covertHexToRgbArray = (hex) => {
    const redColor = parseInt(hex[1] + hex[2], 16);
    const greenColor = parseInt(hex[3] + hex[4], 16);
    const blueColor = parseInt(hex[5] + hex[6], 16);
    const rgb = [redColor, greenColor, blueColor];
    return rgb;
};

export const colorNameToVector4 = (name: string): THREE.Vector4 => {
    // Create fake div
    const fakeDiv = document.createElement("div");
    fakeDiv.style.color = name;
    document.body.appendChild(fakeDiv);

    // Get color of div
    const cs = window.getComputedStyle(fakeDiv);
    const rgb = cs.getPropertyValue("color");

    // Remove div after obtaining desired color value
    document.body.removeChild(fakeDiv);

    const sep = rgb.indexOf(",") > -1 ? "," : " ";
    const rgbSplit = rgb.substring(4).split(")")[0].split(sep);
    const rgbArray = rgbSplit.map((value) => parseInt(value, 10));

    return new window.THREE.Vector4(rgbArray[0] / 255, rgbArray[1] / 255, rgbArray[2] / 255, 1);
};

const getColorDarkness = (color: THREE.Color) => {
    return color.r * 255 * 0.299 + color.g * 255 * 0.587 + color.b * 255 * 0.114;
};

export const checkIfIsLight = (colorHex: string) => {
    const rgbColor = colorHexToRgb(colorHex);
    const colorDarkness = getColorDarkness(rgbColor);
    if (colorDarkness > 180) {
        return true;
    }
    return false;
};

export const getColorFromGradient = (current: number, max: number) => {
    const hue = ((1 - current / max) * 120).toString(10);
    return ["hsl(", hue, ",100%,50%)"].join("");
};

export const hslToHex = (h: number, s: number, l: number) => {
    const lScaled = l / 100;
    const a = (s * Math.min(lScaled, 1 - lScaled)) / 100;
    const f = (n: number) => {
        const k = (n + h / 30) % 12;
        const color = lScaled - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color)
            .toString(16)
            .padStart(2, "0");
    };
    return `#${f(0)}${f(8)}${f(4)}`;
};

export const intersectSphereBox = (sphere: THREE.Sphere, box: THREE.Box3): boolean => {
    const closest = new window.THREE.Vector3(sphere.center.x, sphere.center.y, sphere.center.z);
    // Get box closest point to sphere center by clamping
    closest.clamp(box.min, box.max);

    const distance = sphere.center.distanceToSquared(closest);
    return distance < sphere.radius * sphere.radius;
};

export const getDateXDaysAgo = (numOfDays: number, date = new Date()) => {
    const daysAgo = new Date(date.getTime());
    daysAgo.setDate(date.getDate() - numOfDays);
    return daysAgo;
};

export const getDateXHoursAgo = (numOfHours: number, date = new Date()) => {
    const numberOfMlSeconds = date.getTime();
    const hoursInMlSeconds = numOfHours * 60 * 60 * 1000;
    const newDate = new Date(numberOfMlSeconds - hoursInMlSeconds);
    return newDate;
};

export const F4EWParts = {
    p1: [
        370815, 371161, 371165, 371255, 371303, 371559, 371831, 371847, 371899, 371901, 371907,
        371921, 371945, 371949, 371951, 371963, 373758, 373801, 373817, 373835, 373859, 374082,
        374085, 374121, 374124, 374157, 374160, 374163, 374181, 374187, 374190, 374193, 374196,
        374211, 374262, 374265, 374268, 374271, 374274, 374277, 374289, 374394, 374397, 374429,
        374432, 374435, 374438, 374441, 374477, 374489, 374535, 374538, 374541, 374544, 374575,
        374578, 374581, 374584, 374587, 374803, 374825, 374828, 374831, 374882, 374885, 374888,
        374891, 374894, 374897, 374900, 374969, 374972, 374975, 374978, 374981, 374999, 375002,
        375005, 375026, 375029, 375032, 375035, 375038, 375041, 375044, 375137, 375140, 375143,
        375171, 375174, 375213, 375234, 375251, 375254, 375257, 375260, 375263, 375281, 375290,
        375293, 375296, 375566, 375569, 375572, 375575, 375578, 375581, 375584, 375587, 375590,
        375593, 375596, 375599, 375602, 375605, 375608, 375611, 375614, 375617, 375620, 375629,
        375632, 375635, 375638, 375641, 375644, 375647, 375650, 375701, 375704, 375707, 375710,
        375758, 375761, 375764, 375902, 375905, 375908, 375911, 375914, 376329, 376332, 376346,
        377573, 377582, 377594, 377612, 377642, 377658, 377698, 377728, 377740, 377765, 377799,
        377802, 377829, 377832, 378688, 378719, 378722, 378731, 378734, 378737, 378815, 378854,
        378878, 379109, 379256, 379262, 379265, 379418, 379487, 379517, 379565, 379625, 379634,
        379646, 379652, 379700, 379712, 379715, 379718, 379763, 379820, 379826, 379891, 379957,
        380503, 380506, 380509, 380536, 380569, 381071, 381230, 381236, 381239, 381446, 381452,
        381533, 381557, 381560, 381566, 381569, 381587, 381605, 381608, 381614, 381620, 381635,
        381638, 381641, 381659, 381662, 383217, 383247, 383253, 383613, 383742, 383754, 383766,
        383769, 383887, 383890, 383908, 383911, 383913, 383914, 383968, 383974, 383977, 384004,
        384007, 384064, 384115, 384124, 384127, 384211, 384223, 384226, 384241, 384280, 384283,
        384391, 384394, 384481, 384486, 384493, 384496, 384538, 384541, 384616, 384619, 384622,
        384625, 384628, 384631, 384634, 384637, 384658, 384661, 384811, 384823, 384826, 384832,
        384835, 384838, 384997, 385126, 385144, 385147, 385150, 385162, 385225, 385228, 385231,
        385234, 385405, 385408, 385410, 385411, 385414, 385543, 385549, 385552, 385678, 385705,
        385714, 385780, 385783, 385807, 385888, 385891, 385894, 385942, 385944, 385945, 385948,
        385969, 385972, 386011, 386014, 386035, 386038, 386056, 386059, 386062, 386065, 386068,
        386071, 386077, 386092, 386110, 386113, 386116, 386119, 386152, 386155, 386297, 386300,
        386309, 386315, 386318, 386327, 386450, 386453, 386456, 386459, 386462, 386465, 386468,
        386471, 386474, 386501, 386504, 386507, 386510, 386516, 386594, 386597, 386645, 386807,
        386927, 386930, 387026, 387032, 387041, 387044, 387047, 387056, 387059, 387067, 387068,
        387071, 387125, 387128, 387133, 387137, 387140, 387155, 387158, 387161, 387164, 387167,
        387170, 387173, 387176, 387432, 387433, 387435, 387436, 387852, 387859, 387874, 387889,
        387954, 388003, 388188, 388189, 388192, 388329, 388335, 388338, 388348, 388350, 388354,
        388356, 388360, 388372, 388375, 388384, 388560, 388561, 388590, 388594, 388597, 388599,
        388602, 388663, 388666, 389005, 389013, 389017, 389118, 389127, 389213, 389235, 389293,
        389320, 389323, 389332, 389352, 389353, 389359, 389365, 389371,
    ],
    p2: [
        371279, 371319, 371835, 371893, 371895, 371897, 371907, 371911, 371913, 371917, 371921,
        371931, 371933, 371941, 371943, 371947, 371951, 371955, 371957, 373712, 373738, 373819,
        373820, 373874, 373896, 374027, 374063, 374082, 374088, 374127, 374133, 374166, 374214,
        374217, 374220, 374223, 374226, 374229, 374232, 374247, 374253, 374256, 374259, 374388,
        374391, 374415, 374444, 374447, 374486, 374541, 374544, 374547, 374550, 374553, 374556,
        374903, 374984, 374987, 374990, 374993, 374996, 375008, 375011, 375014, 375017, 375023,
        375029, 375032, 375035, 375038, 375041, 375047, 375050, 375053, 375056, 375059, 375062,
        375065, 375068, 375071, 375074, 375077, 375080, 375125, 375177, 375183, 375186, 375189,
        375213, 375216, 375248, 375251, 375629, 375632, 375635, 375638, 375653, 375656, 375659,
        375662, 375665, 375668, 375671, 375674, 375683, 375686, 375689, 375692, 375695, 375698,
        375713, 375716, 375719, 375722, 375725, 375728, 375731, 375734, 375737, 375743, 375746,
        375749, 375752, 375755, 375767, 375776, 375815, 375818, 375821, 375917, 375920, 375926,
        375929, 375932, 376321, 376324, 377269, 377433, 377612, 377615, 377618, 377621, 377633,
        377639, 377681, 377716, 377737, 377762, 377768, 377785, 377790, 377796, 377823, 377973,
        378691, 378713, 378716, 378719, 378725, 378728, 378878, 378881, 378884, 378899, 379076,
        379085, 379088, 379181, 379250, 379253, 379259, 379367, 379370, 379511, 379541, 379658,
        379664, 379670, 379673, 379757, 379760, 379763, 379963, 379966, 379969, 379972, 379975,
        380116, 380476, 380491, 380494, 380497, 380521, 380524, 380530, 380566, 381095, 381101,
        381179, 381185, 381221, 381224, 381233, 381245, 381362, 381440, 381455, 381458, 381581,
        381602, 381611, 381617, 381629, 381641, 381647, 381650, 383562, 383592, 383595, 383598,
        383601, 383694, 383706, 383757, 383893, 383914, 383917, 383992, 383995, 383998, 384064,
        384124, 384166, 384220, 384229, 384232, 384235, 384238, 384247, 384277, 384280, 384283,
        384382, 384385, 384388, 384433, 384553, 384556, 384559, 384565, 384574, 384595, 384598,
        384601, 384604, 384607, 384613, 384643, 384661, 384673, 384814, 384817, 384832, 384835,
        384838, 384844, 384847, 384850, 384853, 384856, 384859, 384862, 385120, 385123, 385126,
        385132, 385134, 385138, 385153, 385155, 385159, 385165, 385168, 385177, 385240, 385273,
        385348, 385378, 385384, 385387, 385390, 385393, 385398, 385399, 385402, 385528, 385531,
        385537, 385540, 385585, 385588, 385591, 385594, 385597, 385600, 385612, 385615, 385617,
        385618, 385687, 385696, 385717, 385720, 385864, 385867, 385870, 385996, 386005, 386008,
        386014, 386017, 386020, 386023, 386044, 386047, 386068, 386071, 386092, 386306, 386465,
        386477, 386480, 386483, 386485, 386486, 386489, 386491, 386492, 386495, 386498, 386507,
        386510, 386513, 386519, 386522, 386528, 386531, 386533, 386534, 386537, 386540, 386543,
        386546, 386552, 386606, 386656, 386660, 386894, 386897, 386900, 386906, 386909, 386912,
        386915, 386918, 386924, 386927, 387029, 387115, 387158, 387161, 387173, 387176, 387916,
        387930, 387966, 388042, 388072, 388078, 388306, 388317, 388320, 388333, 388335, 388386,
        388393, 388563, 388566, 388570, 388588, 388590, 388672, 388680, 388686, 389054, 389056,
        389066, 389068, 389106, 389115, 389130, 389201, 389210, 389241, 389275, 389293, 389299,
        389326, 389329, 389332, 389335, 389359,
    ],
    p3: [
        371397, 371439, 371457, 371499, 371503, 371569, 371573, 371887, 371889, 371891, 371919,
        371941, 371955, 371957, 371959, 371961, 371969, 372175, 372241, 372245, 372247, 372253,
        372261, 372263, 372267, 372297, 372301, 372303, 372305, 372307, 372311, 372321, 372335,
        372339, 372341, 372343, 372347, 372349, 372979, 373111, 373121, 373183, 373191, 373203,
        373689, 373691, 373693, 373697, 373704, 373755, 373769, 373832, 373841, 373856, 373862,
        373865, 373880, 373910, 373923, 373924, 373927, 373936, 373939, 374091, 374094, 374097,
        374100, 374127, 374130, 374136, 374202, 374229, 374232, 374235, 374238, 374241, 374280,
        374286, 374385, 374388, 374391, 374415, 374468, 374496, 374499, 374502, 374505, 374559,
        374562, 374565, 374568, 374806, 375074, 375077, 375083, 375086, 375089, 375092, 375095,
        375098, 375101, 375104, 375107, 375110, 375113, 375116, 375119, 375122, 375192, 375195,
        375198, 375201, 375225, 375228, 375231, 375550, 375553, 375556, 375559, 375626, 375749,
        375752, 375755, 375779, 375812, 375815, 375818, 375821, 375824, 375830, 375857, 375863,
        375866, 375869, 375872, 375875, 375878, 375881, 375884, 375887, 375890, 375932, 375938,
        375941, 376133, 376142, 376181, 376219, 376222, 376225, 376228, 376231, 376234, 376237,
        376240, 376249, 376297, 376300, 376303, 376314, 376321, 376324, 377269, 377271, 377576,
        377579, 377621, 377624, 377627, 377636, 377646, 377687, 377692, 377722, 377725, 377734,
        377771, 377790, 377793, 377796, 377823, 377858, 377882, 377970, 378694, 378704, 378707,
        378710, 378713, 378770, 378818, 378887, 378890, 378893, 378896, 378902, 378986, 379097,
        379148, 379157, 379160, 379181, 379187, 379190, 379214, 379220, 379223, 379226, 379238,
        379241, 379244, 379247, 379343, 379361, 379409, 379415, 379445, 379511, 379844, 379850,
        379975, 379987, 379993, 380107, 380305, 380368, 380494, 380497, 380518, 380527, 381122,
        381131, 381137, 381143, 381176, 381188, 381191, 381194, 381212, 381218, 381335, 381455,
        381461, 381590, 381593, 381596, 381599, 381626, 381629, 382500, 383091, 383100, 383124,
        383127, 383145, 383148, 383157, 383277, 383298, 383411, 383580, 383679, 383920, 383923,
        383926, 383983, 383986, 383989, 383992, 383994, 383995, 383998, 384028, 384037, 384079,
        384169, 384172, 384247, 384250, 384253, 384259, 384262, 384265, 384268, 384274, 384277,
        384298, 384301, 384304, 384307, 384367, 384370, 384373, 384376, 384382, 384430, 384436,
        384439, 384478, 384574, 384577, 384580, 384583, 384586, 384592, 384640, 384664, 384670,
        384808, 384853, 384856, 384859, 384862, 384865, 384868, 384871, 384874, 384880, 384883,
        384885, 384889, 384895, 384982, 384985, 384988, 384991, 384994, 385003, 385195, 385200,
        385246, 385249, 385252, 385258, 385273, 385276, 385285, 385288, 385291, 385294, 385297,
        385300, 385318, 385321, 385324, 385327, 385333, 385336, 385351, 385357, 385368, 385372,
        385378, 385384, 385417, 385528, 385531, 385537, 385540, 385585, 385588, 385591, 385594,
        385597, 385600, 385612, 385617, 385618, 385624, 385687, 385690, 385717, 385720, 385756,
        385759, 385762, 385765, 385768, 385771, 385774, 385777, 385813, 385816, 385834, 385867,
        385924, 385996, 386002, 386005, 386008, 386023, 386041, 386044, 386131, 386176, 386182,
        386189, 386195, 386555, 386558, 386561, 386564, 386570, 386573, 386576, 386582, 386585,
        386588, 386590, 386633, 386768, 386771, 386777, 386780, 387420, 387421, 388108, 388128,
        388138, 388176, 388197, 388206, 388287, 388290, 388578, 388581, 388681, 388692, 388696,
        388752, 388843, 388896, 388911, 388912, 388957, 389062, 389064, 389066, 389106, 389139,
        389207, 389241, 389269, 389275, 389284, 389299, 389317, 389329, 389380,
    ],
    p4: [
        371481, 371959, 372277, 372279, 372281, 372283, 372285, 372287, 372291, 372293, 372295,
        372297, 372299, 372301, 372303, 372305, 372307, 372309, 372311, 372313, 372315, 372317,
        372319, 372323, 372329, 372331, 372333, 372337, 373838, 373942, 373979, 373994, 373997,
        374036, 374039, 374066, 374069, 374097, 374139, 374199, 374241, 374286, 374379, 374382,
        374468, 374496, 374499, 374502, 374505, 375119, 375122, 375550, 375553, 375556, 375559,
        375626, 376351, 376354, 377576, 377692, 378694, 378704, 378748, 378751, 378759, 378762,
        378782, 378842, 378929, 378932, 378935, 378941, 378944, 378947, 378950, 379187, 379190,
        379193, 379220, 379241, 379271, 379322, 379334, 379358, 379442, 379682, 379685, 379829,
        380020, 380092, 380290, 381197, 381203, 381206, 381590, 381626, 381653, 383842, 383845,
        383863, 383866, 383869, 383872, 383926, 384037, 384169, 384172, 384259, 384262, 384265,
        384268, 384292, 384352, 384355, 384361, 384364, 384367, 384370, 384373, 384430, 384586,
        384592, 384664, 384667, 384670, 384808, 384889, 384892, 384895, 385276, 385288, 385291,
        385296, 385297, 385300, 385303, 385309, 385324, 385327, 385339, 385353, 385417, 385504,
        385507, 385510, 385513, 385516, 385519, 385813, 385816, 385858, 385861, 385882, 386026,
        386029, 386089, 386164, 386167, 386170, 386173, 386195, 386249, 386252, 386255, 386741,
        386744, 386747, 388182, 388273, 388279, 389084, 389087, 389183, 389317,
    ],
};

export const F4WWParts = {
    p1: [
        370813, 370949, 370983, 371697, 371731, 372419, 372421, 372423, 372425, 372427, 372433,
        372439, 372441, 372449, 372451, 372467, 372469, 372471, 372473, 372475, 372477, 372483,
        372485, 372491, 372493, 372551, 372567, 372569, 372571, 372573, 372575, 372577, 372579,
        372593, 372595, 372597, 372653, 372667, 372669, 372671, 372673, 372675, 372677, 372683,
        372689, 372693, 372695, 372697, 372699, 372713, 372743, 372745, 372747, 372789, 372791,
        372793, 372795, 372797, 372799, 372801, 372803, 372805, 372807, 372809, 372811, 372815,
        372817, 372819, 372821, 372823, 372825, 372827, 372833, 372835, 372837, 372839, 372841,
        372883, 372885, 372887, 372889, 372891, 372893, 372899, 372901, 372935, 372937, 372939,
        372941, 372943, 372945, 372947, 373153, 373277, 373283, 373447, 373455, 373457, 373487,
        373489, 373495, 373497, 373499, 373505, 373507, 373509, 373515, 373517, 373519, 373521,
        373527, 373529, 373531, 373549, 373565, 373567, 373569, 373571, 373573, 373575, 373577,
        373579, 373581, 373583, 373585, 373603, 373605, 373607, 373609, 373613, 373615, 373617,
        373621, 373623, 373625, 373629, 373653, 373657, 373659, 373661, 373669, 373671, 373673,
        373675, 373677, 373679, 373982, 373985, 373988, 373991, 374044, 374045, 374048, 374051,
        374060, 374115, 374118, 374175, 374178, 374184, 374292, 374295, 374298, 374301, 374304,
        374307, 374355, 374358, 374361, 374367, 374370, 374409, 374412, 374456, 374459, 374462,
        374465, 374471, 374480, 374492, 374511, 374514, 374571, 374617, 374620, 374623, 374626,
        374629, 374632, 374635, 374638, 374683, 374686, 374689, 374692, 374695, 374698, 374701,
        374707, 374710, 374713, 374716, 374719, 374722, 374725, 374728, 374812, 374815, 374818,
        374906, 374909, 374912, 374954, 374957, 374960, 375147, 375150, 375266, 375269, 375278,
        375284, 375299, 375405, 375408, 375411, 375414, 375417, 375420, 375423, 375426, 375429,
        375432, 375447, 375450, 375453, 375456, 375459, 375462, 375465, 375468, 375483, 375486,
        375489, 375492, 375495, 375498, 375501, 375504, 375507, 375510, 375513, 375516, 375519,
        375522, 375525, 375528, 375531, 375534, 375537, 375803, 375806, 375809, 376335, 376338,
        376342, 377037, 377588, 377591, 377600, 377661, 377704, 377731, 377750, 377756, 377805,
        377808, 377844, 377847, 377855, 378012, 378015, 378018, 378021, 378024, 378027, 378030,
        378147, 378150, 378153, 378186, 378189, 378192, 378264, 378267, 378270, 378276, 378279,
        378282, 378285, 378288, 378339, 378342, 378345, 378348, 378366, 378812, 378848, 378851,
        378869, 378962, 378971, 378989, 378992, 378995, 378998, 379001, 379004, 379010, 379019,
        379049, 379052, 379055, 379304, 379313, 379349, 379352, 379376, 379379, 379382, 379385,
        379388, 379766, 379799, 379802, 379805, 379808, 379811, 379841, 379864, 379867, 380002,
        380131, 380134, 380137, 380140, 380143, 380146, 380149, 380152, 380155, 380158, 380161,
        380164, 380167, 380170, 380173, 380227, 380230, 380263, 380266, 380640, 380688, 380895,
        380901, 380904, 380907, 380937, 380958, 381089, 381092, 381161, 381248, 381251, 381257,
        381287, 381290, 381293, 381296, 381353, 381395, 381464, 381470, 381473, 381509, 381521,
        381524, 382710, 382713, 382722, 382725, 382728, 382758, 382761, 382764, 383178, 383181,
        383259, 383268, 383402, 383458, 383461, 383464, 383467, 383470, 383473, 383476, 383530,
        383533, 383536, 383539, 383553, 383619, 383622, 383643, 383790, 383959, 383962, 383965,
        384010, 384088, 384097, 384109, 384133, 384136, 384178, 384180, 384181, 384421, 384424,
        384454, 384457, 384460, 384676, 384679, 384682, 384685, 384688, 384691, 384694, 384697,
        384754, 384757, 384760, 384763, 384769, 384787, 384790, 384916, 384931, 384934, 384937,
        384943, 384946, 384949, 384952, 384955, 384970, 385009, 385012, 385015, 385018, 385021,
        385033, 385048, 385429, 385432, 385435, 385477, 385480, 385489, 385573, 385576, 385579,
        385582, 385654, 385657, 385723, 385726, 385729, 385732, 385735, 385738, 385744, 385750,
        386134, 386137, 386140, 386143, 386267, 386270, 386273, 386276, 386279, 386282, 386285,
        386288, 386291, 386294, 386357, 386360, 386363, 386366, 386369, 386372, 386375, 386378,
        386381, 386384, 386387, 386390, 386707, 386708, 386711, 386714, 386717, 386720, 386723,
        386726, 386729, 386732, 386738, 386753, 386759, 386810, 386813, 386816, 386819, 386822,
        386825, 386834, 386836, 386837, 386840, 386870, 386873, 386876, 386879, 386936, 386966,
        386984, 387017, 387185, 387197, 387442, 387445, 387544, 387547, 387556, 387574, 387592,
        387628, 387637, 387643, 387648, 387649, 387655, 388222, 388228, 388537, 388540, 388543,
        388545, 388546, 388549, 388552, 388555, 388558, 388606, 388609, 388708, 388711, 388713,
        388714, 389034, 389036, 389038, 389070, 389074, 389163, 389166, 389169, 389172,
    ],
    p2: [
        370851, 370867, 370885, 370901, 371029, 371033, 371875, 371877, 371925, 372357, 372359,
        372361, 372365, 372387, 372393, 372395, 372397, 372417, 372509, 372535, 372537, 372539,
        372545, 372549, 372583, 372587, 372599, 372601, 372605, 372663, 372665, 372681, 372685,
        372707, 372715, 372763, 372765, 372767, 372771, 372773, 372777, 372779, 372781, 372783,
        372841, 372843, 372845, 372847, 372849, 372851, 372853, 372863, 372867, 372869, 372875,
        372877, 372881, 372923, 372925, 373151, 373155, 373157, 373253, 373279, 373281, 373283,
        373449, 373451, 373459, 373463, 373469, 373475, 373477, 373479, 373485, 373487, 373489,
        373495, 373539, 373541, 373543, 373563, 373565, 373593, 373597, 373599, 373611, 373631,
        373633, 373635, 373637, 373641, 373709, 373735, 373826, 373868, 374103, 374109, 374142,
        374169, 374172, 374310, 374313, 374316, 374319, 374343, 374349, 374364, 374400, 374450,
        374453, 374456, 374483, 374517, 374520, 374529, 374532, 374641, 374644, 374647, 374650,
        374653, 374656, 374659, 374662, 374665, 374668, 374671, 374674, 374677, 374680, 374704,
        374731, 374734, 374737, 374740, 374743, 374746, 374749, 374752, 374755, 374758, 374761,
        374764, 374767, 374770, 374773, 374776, 374915, 374918, 374924, 374936, 374939, 374942,
        374945, 374948, 374951, 375272, 375275, 375315, 375318, 375321, 375324, 375327, 375336,
        375339, 375345, 375348, 375351, 375354, 375357, 375360, 375363, 375366, 375369, 375372,
        375375, 375378, 375381, 375384, 375387, 375435, 375438, 375441, 375444, 375447, 375450,
        375453, 375456, 375471, 375474, 375477, 375480, 375537, 375540, 375543, 375546, 375791,
        375797, 376311, 376318, 376537, 376553, 377585, 377597, 377603, 377606, 377630, 377707,
        377710, 377747, 377753, 377817, 377835, 377864, 377867, 378372, 378806, 378845, 378857,
        378860, 378863, 378866, 378905, 379007, 379031, 379058, 379061, 379064, 379286, 379307,
        379316, 379553, 379571, 379622, 379784, 379876, 379879, 379882, 379954, 380128, 380176,
        380191, 380221, 380224, 380248, 380251, 380269, 380272, 380275, 380287, 380413, 380422,
        380694, 380925, 381033, 381039, 381068, 381086, 381254, 381260, 381263, 381284, 381299,
        381311, 381314, 381317, 381326, 381350, 381467, 381512, 381515, 381518, 381536, 381545,
        382635, 382653, 382665, 382668, 382683, 382686, 382695, 382791, 383625, 383628, 383646,
        383658, 383664, 383784, 383824, 383827, 383830, 383839, 383857, 383947, 383950, 384085,
        384091, 384093, 384094, 384097, 384117, 384118, 384121, 384130, 384139, 384157, 384160,
        384163, 384184, 384199, 384286, 384316, 384319, 384340, 384343, 384400, 384406, 384418,
        384447, 384448, 384451, 384454, 384472, 384475, 384700, 384703, 384705, 384706, 384709,
        384712, 384736, 384739, 384742, 384745, 384748, 384766, 384790, 384931, 384961, 384964,
        384967, 384979, 385041, 385054, 385057, 385062, 385063, 385092, 385093, 385096, 385099,
        385102, 385105, 385108, 385111, 385423, 385426, 385441, 385447, 385450, 385465, 385468,
        385473, 385474, 385492, 385495, 385498, 385555, 385558, 385666, 385843, 385849, 385852,
        385909, 385911, 385912, 385981, 385984, 386258, 386261, 386264, 386333, 386336, 386339,
        386342, 386345, 386348, 386351, 386354, 386393, 386396, 386399, 386402, 386405, 386408,
        386411, 386414, 386417, 386420, 386423, 386426, 386429, 386681, 386690, 386693, 386750,
        386762, 386846, 386849, 386882, 386885, 386938, 386956, 387188, 387191, 387453, 387454,
        387496, 387499, 387508, 387664, 387672, 387673, 387679, 387685, 387706, 387715, 388486,
        388492, 388495, 388504, 388506, 388507, 388510, 388519, 388522, 388525, 388533, 388629,
        389145, 389160,
    ],
    p3: [
        370741, 371065, 371093, 371121, 371133, 371541, 371545, 371547, 371875, 371877, 371879,
        371881, 371883, 371885, 371923, 371937, 371965, 371967, 372351, 372353, 372355, 372357,
        372365, 372515, 372525, 372527, 372553, 372557, 372565, 372591, 372609, 372613, 372627,
        372629, 372631, 372633, 372641, 372649, 372651, 372655, 372657, 372659, 372661, 372685,
        372701, 372703, 372709, 372711, 372717, 372719, 372721, 372723, 372731, 372733, 372737,
        372749, 372753, 372755, 372757, 372759, 372761, 372851, 372853, 372855, 372857, 372859,
        372861, 372863, 372865, 372875, 372877, 372903, 372905, 372907, 372909, 372911, 372913,
        372915, 372917, 372919, 372921, 372923, 372925, 372927, 372929, 372931, 372951, 372957,
        372961, 372963, 372965, 372967, 372969, 372971, 372973, 372977, 372981, 373015, 373019,
        373063, 373067, 373069, 373071, 373073, 373075, 373077, 373079, 373123, 373151, 373155,
        373157, 373223, 373225, 373253, 373255, 373257, 373259, 373261, 373263, 373265, 373267,
        373269, 373273, 373275, 373279, 373285, 373287, 373369, 373373, 373407, 373409, 373411,
        373413, 373417, 373419, 373421, 373427, 373449, 373459, 373537, 373539, 373541, 373543,
        373631, 373635, 373637, 373641, 373643, 373645, 373647, 373651, 373681, 373683, 373685,
        373695, 373709, 373735, 373743, 373806, 373823, 373826, 373829, 373844, 373847, 373853,
        373868, 373877, 373886, 373930, 373933, 373945, 373957, 374002, 374012, 374015, 374018,
        374021, 374024, 374030, 374033, 374106, 374109, 374112, 374142, 374145, 374148, 374151,
        374154, 374205, 374322, 374325, 374328, 374331, 374334, 374337, 374340, 374343, 374373,
        374376, 374400, 374403, 374406, 374418, 374423, 374426, 374474, 374508, 374523, 374526,
        374764, 374767, 374770, 374773, 374776, 374779, 374782, 374785, 374788, 374791, 374794,
        374797, 374800, 374809, 374870, 374873, 374924, 374927, 374933, 374963, 374966, 375128,
        375131, 375134, 375153, 375156, 375159, 375162, 375165, 375168, 375204, 375207, 375239,
        375242, 375245, 375275, 375303, 375306, 375309, 375312, 375315, 375318, 375321, 375324,
        375327, 375336, 375339, 375342, 375345, 375348, 375351, 375354, 375357, 375546, 375785,
        375788, 375791, 375833, 375836, 375839, 375842, 375845, 375848, 375851, 375854, 375893,
        375896, 375899, 375945, 375948, 375951, 376032, 376186, 376189, 376192, 376195, 376198,
        376201, 376207, 376210, 376216, 376252, 376308, 376311, 376318, 377609, 377649, 377652,
        377655, 377674, 377695, 377701, 377713, 377744, 377774, 377811, 377814, 377817, 377835,
        377838, 377841, 377861, 378312, 378372, 378742, 378745, 378756, 378767, 378785, 378788,
        378791, 378794, 378797, 378803, 378806, 378809, 378830, 378836, 378845, 378860, 378872,
        378905, 378911, 378917, 378923, 379031, 379058, 379061, 379163, 379166, 379175, 379178,
        379232, 379235, 379286, 379289, 379292, 379319, 379448, 379481, 379490, 379568, 379619,
        379622, 379730, 379781, 379784, 379858, 379882, 379885, 379939, 379996, 380086, 380194,
        380197, 380200, 380203, 380206, 380209, 380212, 380218, 380221, 380224, 380260, 380275,
        380278, 380284, 380287, 380308, 380314, 380356, 380380, 380422, 380563, 380925, 380955,
        381030, 381074, 381158, 381260, 381269, 381272, 381275, 381278, 381281, 381284, 381314,
        381320, 381323, 381326, 381344, 381347, 381350, 381365, 381545, 381623, 381656, 382572,
        382635, 382638, 382641, 382653, 382851, 382854, 382857, 382863, 382881, 383568, 383631,
        383634, 383637, 383772, 383824, 383836, 383839, 383848, 383851, 383854, 383857, 383875,
        383878, 383881, 383884, 383896, 383899, 383902, 383905, 383935, 383938, 383941, 383944,
        383947, 383950, 383953, 383956, 384013, 384016, 384019, 384022, 384024, 384025, 384031,
        384034, 384040, 384043, 384049, 384052, 384055, 384058, 384067, 384085, 384091, 384106,
        384118, 384121, 384130, 384142, 384144, 384145, 384148, 384151, 384154, 384157, 384163,
        384319, 384322, 384325, 384334, 384337, 384342, 384343, 384349, 384397, 384409, 384412,
        384415, 384442, 384445, 384448, 384463, 384466, 384469, 384517, 384523, 384529, 384532,
        384718, 384721, 384724, 384727, 384733, 384739, 384742, 384745, 384781, 384793, 384799,
        384961, 384964, 384973, 384976, 384979, 385000, 385006, 385045, 385054, 385057, 385062,
        385063, 385078, 385081, 385084, 385087, 385096, 385108, 385111, 385264, 385341, 385342,
        385345, 385420, 385423, 385450, 385453, 385458, 385462, 385465, 385468, 385471, 385474,
        385492, 385495, 385498, 385555, 385558, 385561, 385564, 385567, 385570, 385627, 385666,
        385819, 385821, 385822, 385825, 385831, 385837, 385840, 385843, 385852, 385855, 385902,
        385906, 385909, 385912, 385957, 385975, 385981, 386083, 386086, 386098, 386101, 386104,
        386146, 386158, 386179, 386192, 386258, 386261, 386321, 386324, 386423, 386432, 386435,
        386438, 386441, 386444, 386447, 386609, 386612, 386615, 386618, 386621, 386624, 386627,
        386630, 386668, 386669, 386675, 386681, 386696, 386699, 386750, 386762, 386858, 386860,
        386863, 386864, 386867, 387187, 387191, 387208, 387228, 387240, 387241, 387454, 387457,
        387459, 387721, 387727, 387750, 387754, 387756, 387760, 387765, 387769, 387771, 387790,
        387798, 387805, 387811, 387817, 388255, 388261, 388267, 388462, 388465, 388468, 388471,
        388474, 388477, 388480, 388489, 388492, 388494, 388504, 388507, 388510, 388650, 388651,
        388657, 389044, 389048, 389092, 389095, 389145, 389148, 389151, 389154, 389190, 389195,
        389218, 389221, 389226, 389249, 389252, 389255, 389258, 389264, 389272, 389290, 389296,
        389302, 389305, 389308, 389311, 389314, 389338, 389344, 389356, 389368, 389373, 389374,
        389377,
    ],
};

const FAtriumParts = {
    p1: [
        370723, 370729, 371745, 371825, 371973, 371977, 371979, 371981, 371987, 371989, 371997,
        372021, 372031, 372037, 372047, 372063, 372069, 372081, 372085, 372089, 372093, 372097,
        372105, 372107, 372109, 372111, 372125, 372141, 372151, 372153, 372155, 372157, 372159,
        372161, 372177, 372179, 372183, 372203, 372263, 372265, 372267, 372269, 372271, 372987,
        373003, 373019, 373035, 373047, 373049, 373051, 373055, 373059, 373079, 373081, 373085,
        373103, 373107, 373111, 373117, 373119, 373121, 373143, 373149, 373159, 373163, 373171,
        373173, 373175, 373183, 373185, 373189, 373191, 373195, 373197, 373199, 373201, 373203,
        373209, 373215, 373217, 373221, 373227, 373229, 373231, 373233, 373235, 373237, 373239,
        373241, 373243, 373245, 373247, 373249, 373251, 373257, 373259, 373263, 373297, 373303,
        373307, 373309, 373311, 373315, 373319, 373321, 373323, 373327, 373331, 373335, 373343,
        373347, 373351, 373359, 373361, 373363, 373365, 373367, 373369, 373417, 373429, 373431,
        373433, 373435, 373437, 373441, 373443, 374136, 374205, 374376, 374593, 374596, 374599,
        374602, 374605, 374608, 374611, 374614, 374834, 374837, 374840, 374843, 374849, 374852,
        374855, 374858, 374861, 374864, 374867, 374870, 374873, 374876, 374879, 375958, 375961,
        375964, 375967, 375970, 375973, 375982, 375985, 375988, 375991, 375994, 375997, 376000,
        376003, 376006, 376009, 376012, 376015, 376018, 376021, 376024, 376100, 376106, 376109,
        376112, 376115, 376121, 376124, 376127, 376130, 376133, 376136, 376142, 376145, 376148,
        376151, 376157, 376160, 376163, 376166, 376175, 376178, 376181, 376219, 376222, 376225,
        376228, 376231, 376252, 376255, 376258, 376261, 376264, 376267, 376270, 376273, 376276,
        376279, 376282, 376285, 376288, 376291, 376294, 376297, 376300, 378542, 378545, 378563,
        378575, 378581, 378623, 378626, 378638, 378641, 378653, 379160, 379178, 379409, 380371,
        381021, 381476, 381488, 381491, 381700, 382255, 382261, 382429, 382450, 382453, 382456,
        382459, 382465, 382471, 382569, 382578, 382581, 382584, 382590, 382593, 382596, 382599,
        382605, 382608, 382614, 382617, 382620, 382629, 383250, 383277, 383280, 383283, 383286,
        383289, 383292, 383295, 383298, 383301, 383304, 383307, 383310, 383313, 383316, 383363,
        383369, 383372, 383378, 383384, 383390, 383399, 383411, 383414, 383417, 383420, 383423,
        383429, 383432, 383438, 383441, 383444, 383447, 383450, 384028, 384067, 384973, 385000,
        385264, 385270, 385276, 385753, 385756, 385759, 385774, 385777, 385792, 385795, 385900,
        387319, 387322, 387357, 387397, 387415, 387417, 387418, 387421, 388405, 388408, 388411,
        388413, 388420, 388422, 388423, 388426, 388429, 388432, 388449, 388450, 388459, 388749,
        388752, 388753, 388764, 388779, 388876, 388897, 388899, 388900, 388903, 388906, 388909,
        388912, 388914, 388915, 388918, 388921, 388924, 388927, 388929, 388930, 388933, 388936,
        388939, 388942, 388945, 388948, 388951, 388954, 388956, 388957, 388960, 388963, 388966,
        388969, 389190,
    ],
};
export const F4EWTasks = {
    task0: {
        progress: 0,
        gray: [...F4EWParts.p2, ...F4EWParts.p3, ...F4EWParts.p4],
        yellow: [...F4EWParts.p1],
        green: [],
        red: [],
    },
    task12: {
        progress: 12,
        gray: [...F4EWParts.p3, ...F4EWParts.p4],
        yellow: [...F4EWParts.p2].filter((item) => item !== 378881 && item !== 371893),
        green: [...F4EWParts.p1],
        red: [378881, 371893],
    },
    task35: {
        progress: 35,
        gray: [...F4EWParts.p4],
        yellow: [...F4EWParts.p3, 378881, 371893],
        green: [...F4EWParts.p1, ...F4EWParts.p2].filter(
            (item) => item !== 378881 && item !== 371893
        ),
        red: [],
    },
    task80: {
        progress: 80,
        gray: [],
        yellow: [...F4EWParts.p4],
        green: [...F4EWParts.p1, ...F4EWParts.p2, ...F4EWParts.p3],
        red: [],
    },
    task100: {
        progress: 100,
        gray: [],
        yellow: [],
        green: [...F4EWParts.p1, ...F4EWParts.p2, ...F4EWParts.p3, ...F4EWParts.p4],
        red: [],
    },
};

export const F4WWTasks = {
    task0: {
        progress: 0,
        gray: [...F4WWParts.p2, ...F4WWParts.p3],
        yellow: [...F4WWParts.p1],
        green: [],
        red: [],
    },
    task35: {
        progress: 35,
        gray: [...F4WWParts.p3],
        yellow: [...F4WWParts.p2].filter(
            (item) => item !== 385099 && item !== 384319 && item !== 373539
        ),
        green: [...F4WWParts.p1],
        red: [385099, 384319, 373539],
    },
    task60: {
        progress: 60,
        gray: [],
        yellow: [...F4WWParts.p3, 385099, 384319, 373539],
        green: [...F4WWParts.p1, ...F4WWParts.p2].filter(
            (item) => item !== 385099 && item !== 384319 && item !== 373539
        ),
        red: [],
    },
    task100: {
        progress: 100,
        gray: [],
        yellow: [],
        green: [...F4WWParts.p1, ...F4WWParts.p2, ...F4WWParts.p3],
        red: [],
    },
};

export const FAtriumTasks = {
    task0: {
        progress: 0,
        gray: [],
        yellow: FAtriumParts.p1,
        green: [],
        red: [],
    },
    task100: {
        progress: 100,
        gray: [],
        yellow: [],
        green: FAtriumParts.p1,
        red: [],
    },
};

export const BrokenParts = {
    progress: 0,
    gray: [...F4WWParts.p1, ...F4WWParts.p2, ...F4WWParts.p3].filter((item) => item !== 385099),
    yellow: [],
    green: [],
    red: [385099],
};

export const eastMarks = [
    {
        value: 0,
        label: "",
    },
    {
        value: 25,
        label: "23/07",
    },
    {
        value: 50,
        label: "24/07",
    },
    {
        value: 75,
        label: "25/07",
    },
    {
        value: 100,
        label: "",
    },
];

export const westMarks = [
    {
        value: 0,
        label: "",
    },
    {
        value: 33,
        label: "23/07",
    },
    {
        value: 67,
        label: "25/07",
    },
    {
        value: 100,
        label: "",
    },
];

export const atriumMarks = [
    {
        value: 0,
        label: "",
    },
    {
        value: 100,
        label: "",
    },
];

export const taskMappings = {
    "HVAC Installation  Works-Atrium": {
        "100%": FAtriumTasks.task100,
        default: FAtriumTasks.task0,
    },
    "Installation of HVAC System - Floor 4 East Wing": {
        "100%": F4EWTasks.task100,
        "75%": F4EWTasks.task80,
        "50%": F4EWTasks.task35,
        "25%": F4EWTasks.task12,
        default: F4EWTasks.task0,
    },
    "Installation of HVAC System - Floor 4 West Wing": {
        "100%": F4WWTasks.task100,
        "67%": F4WWTasks.task60,
        "33%": F4WWTasks.task35,
        default: F4WWTasks.task0,
    },
};

export const wingVecs = {
    east: [
        new THREE.Vector4(-1, 0, 0, -260),
        new THREE.Vector4(0, 1, 0, 328),
        new THREE.Vector4(0, -1, 0, -701),
        new THREE.Vector4(1, 0, 0, 175),
    ],
    eastMid: [
        new THREE.Vector4(-1, 0, 0, -260),
        new THREE.Vector4(0, 1, 0, 328),
        new THREE.Vector4(0, -1, 0, -701),
        new THREE.Vector4(1, 0, 0, 128),
    ],
    eastBig: [
        new THREE.Vector4(-1, 0, 0, -260),
        new THREE.Vector4(0, 1, 0, 328),
        new THREE.Vector4(0, -1, 0, -701),
        new THREE.Vector4(1, 0, 0, 55),
    ],
    atrium: [
        new THREE.Vector4(1, 0, 0, 260),
        new THREE.Vector4(-1, -0.18, 0, -465),
        new THREE.Vector4(-0.08, 1, 0, 405),
        new THREE.Vector4(0.1, -1, 0, -598),
    ],
    west: [
        new THREE.Vector4(1, 0.18, 0, 465),
        new THREE.Vector4(-1, -0.18, 0, -555),
        new THREE.Vector4(-0.15, 1, 0, 306),
        new THREE.Vector4(0.165, -1, 0, -643),
    ],
};

export const floorVecs = {
    firstH: [new THREE.Vector4(0, 0, 1, -2.8), new THREE.Vector4(0, 0, -1, -15)],
    firstL: [new THREE.Vector4(0, 0, 1, 5), new THREE.Vector4(0, 0, -1, -15)],
    secondH: [new THREE.Vector4(0, 0, 1, -19.2), new THREE.Vector4(0, 0, -1, 4)],
    secondL: [new THREE.Vector4(0, 0, 1, -15), new THREE.Vector4(0, 0, -1, 4)],
    thirdH: [new THREE.Vector4(0, 0, 1, -36.3), new THREE.Vector4(0, 0, -1, 20)],
    thirdL: [new THREE.Vector4(0, 0, 1, -30), new THREE.Vector4(0, 0, -1, 20)],
    fourthH: [new THREE.Vector4(0, 0, 1, -52.5), new THREE.Vector4(0, 0, -1, 37)],
    fourthL: [new THREE.Vector4(0, 0, 1, -48), new THREE.Vector4(0, 0, -1, 37)],
    roof: [new THREE.Vector4(0, 0, -1, 54)],
};

export const servicesDbids: {
    [key: string]: number[];
} = {
    "Chilled water": [135601, 275241, 318238, 366148, 403460],
    Drainage: [143636, 278936, 320466, 369909, 408936, 267987],
    Ducting: [149796, 282436, 323730, 370669, 409057],
    Electrical: [519666, 203051, 231781, 243522, 256836, 266277],
    "Fire fighting": [171670, 298350, 350523, 389381, 412156],
    "Low current": [211667, 237695, 249147, 262534, 267584],
    Storm: [132160],
    "Water supply": [184120, 309544, 362063, 398593, 412438],
};

export const renderTaskProgress = ({
    progress: progressValue,
    gray,
    yellow,
    green,
    red,
}: {
    progress: number;
    gray: number[];
    yellow: number[];
    green: number[];
    red: number[];
}): void => {
    window.NOP_VIEWER.clearThemingColors(window.NOP_VIEWER.model);
    window.NOP_VIEWER.resetModel(false);
    const allDbIds = [...gray, ...yellow, ...green, ...red];
    window.NOP_VIEWER.fitIsolate(allDbIds, false);

    gray.forEach((dbid) => {
        window.NOP_VIEWER.setThemingColor(dbid, new THREE.Vector4(0.8, 0.8, 0.8, 1));
    });
    yellow.forEach((dbid) => {
        window.NOP_VIEWER.setThemingColor(dbid, new THREE.Vector4(1, 1, 0, 1));
    });
    green.forEach((dbid) => {
        window.NOP_VIEWER.setThemingColor(dbid, new THREE.Vector4(0, 0.8, 0, 1));
    });
    red.forEach((dbid) => {
        window.NOP_VIEWER.setThemingColor(dbid, new THREE.Vector4(1, 0.2, 0.2, 1));
    });
};

export enum ToolbarSection {
    All = "allTools",
    Navigation = "navTools",
    Model = "modelTools",
    Settings = "settingsTools",
}

export enum ToolbarSubSection {
    Navigation_Orbit = "toolbar-orbitTools",
    Navigation_Pan = "toolbar-panTool",
    Navigation_Zoom = "toolbar-zoomTool",
    Navigation_BimWalk = "toolbar-bimWalkTool",
    Navigation_Camera = "toolbar-cameraSubmenuTool",
    Settings_ModelStructure = "toolbar-modelStructureTool",
    Settings_Properties = "toolbar-propertiesTool",
    Settings_Settings = "toolbar-settingsTool",
    Settings_FullScreen = "toolbar-fullscreenTool",
    Model_Measurement = "toolbar-measurementSubmenuTool",
    Model_Section = "toolbar-sectionTool",
    Model_Document = "toolbar-documentModels",
    Model_Explode = "toolbar-explodeTool",
}

export enum NavigationToolbarSection {
    All = "allTools",
    Orbit = "toolbar-orbitTools",
    Pan = "toolbar-panTool",
    Zoom = "toolbar-zoomTool",
    BimWalk = "toolbar-bimWalkTool",
    Camera = "toolbar-cameraSubmenuTool",
}

export enum SettingsToolbarSection {
    All = "allTools",
    ModelStructure = "toolbar-modelStructureTool",
    Properties = "toolbar-propertiesTool",
    Settings = "toolbar-settingsTool",
    FullScreen = "toolbar-fullscreenTool",
}

export enum ModelToolbarSection {
    All = "allTools",
    Measurement = "toolbar-measurementSubmenuTool",
    Section = "toolbar-sectionTool",
    Document = "toolbar-documentModels",
    Explode = "toolbar-explodeTool",
}
